// src/utils/helpers.js

/**
 * Convierte un objeto File a una cadena de texto en formato Base64.
 * @param {File} file - El archivo a convertir.
 * @returns {Promise<string>} Una promesa que se resuelve con la cadena Base64.
 */
export const toBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
});

